import VehicalInfo from './VehicalInfo';
export default VehicalInfo;
